module.exports = __webpack_public_path__ + "img/30.60f08e4c.png";